/**
 * Определяет цвет иконки на основе content-type файла
 * @param contentType - MIME тип файла
 * @returns HEX цвет для иконки
 */
export const getIconColorByContentType = (contentType: string): string => {
  const normalizedType = contentType.toLowerCase();

  // PDF файлы
  if (normalizedType.includes('pdf')) {
    return '#FA5252';
  }

  // Excel файлы
  if (normalizedType.includes('vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
    return '#12B886';
  }

  // Word файлы
  if (normalizedType.includes('doc') || normalizedType.includes('docx')) {
    return '#228BE6';
  }

  // Остальные типы файлов
  return '#ADB5BD';
};
